import { cn } from "@newxsystems/shared";
import { TootActions } from "../../../../modules/layout/components/TootActions/TootActions";
import { TootHeading } from "../../../../modules/layout/components/TootHeading/TootHeading";
import { TootSectionShell } from "../../../../modules/layout/components/TootSectionShell/TootSectionShell";
import { TootOfficeCard } from "../../../../modules/contact/components/TootOfficeCard/TootOfficeCard";
import type { OfficeCardsAddress, IOfficeCardsBlockProps } from "./OfficeCardsBlock.props";

const formatAddress = (address?: OfficeCardsAddress | null) => {
  const locality = [address?.city, [address?.region, address?.postalCode].filter(Boolean).join(" ")]
    .filter(Boolean)
    .join(", ");

  return [address?.line1, address?.line2, locality, address?.country].filter(Boolean) as string[];
};

export const OfficeCardsBlock = ({
  anchorId,
  buttons,
  eyebrow,
  heading,
  offices = [],
  parentClass,
  spacing,
  subheading,
}: IOfficeCardsBlockProps) => {
  return (
    <TootSectionShell
      id={anchorId ?? undefined}
      rootClassName={cn("office-cards-block relative overflow-hidden", parentClass)}
      tone="dark"
      spacing={spacing ?? undefined}
      width="wide"
      header={
        heading ? (
          <TootHeading eyebrow={eyebrow} heading={heading} subheading={subheading} />
        ) : undefined
      }
      actions={buttons?.length ? <TootActions actions={buttons} /> : undefined}
    >
      {offices.length > 0 ? (
        <div className="toot-heat-panel p-4 md:p-5">
          <div className="grid gap-5 xl:gap-6">
            <div className="grid min-w-0 grid-cols-1 gap-4 md:grid-cols-2 xl:gap-5">
              {offices.map((office, index) => (
                <div className="flex min-w-0 flex-col gap-3" key={`${office.name}-${index}`}>
                  <TootOfficeCard
                    addressLines={formatAddress(office.address)}
                    className="flex-1"
                    directionsAriaLabel={office.directionsLink?.ariaLabel ?? undefined}
                    directionsHref={office.directionsLink?.href ?? undefined}
                    directionsLabel={office.directionsLink?.text}
                    directionsRel={
                      office.directionsLink?.target === "_blank" ? "noopener noreferrer" : undefined
                    }
                    directionsTarget={office.directionsLink?.target ?? undefined}
                    email={office.email ?? undefined}
                    emailHref={office.email ? `mailto:${office.email}` : undefined}
                    hours={office.hours ?? undefined}
                    image={office.image ?? undefined}
                    index={index}
                    map={office.map ?? undefined}
                    name={office.name}
                    phone={office.phone ?? undefined}
                    phoneHref={office.phone ? `tel:${office.phone}` : undefined}
                    summary={office.description ?? undefined}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </TootSectionShell>
  );
};

OfficeCardsBlock.displayName = "Block::OfficeCardsBlock";
